import Page from '../../components/Page';
import { observer } from 'mobx-react-lite';
import { Route } from 'react-router-dom';
import Paths from '../../constants/paths';
import ErrorMessages from '../../components/ErrorMessages.js';
import ParkingFields from './ParkingFields';
import ParkingField from './ParkingField';

const ParkingFieldsTab = ({ store }) => {
    return (
        <Page loading={!store.dataLoaded}>
            <div style={{ marginLeft: '2.5%' }}>
                <ErrorMessages messages={store.error} />
            </div>
            <Route exact path={Paths.PARKING_FIELDS}>
                <ParkingFields store={store} />
            </Route>
            <Route exact path={Paths.PARKING_FIELD}>
                <ParkingField store={store} />
            </Route>
        </Page>
    );
};

export default observer(ParkingFieldsTab);
